import request from '@/http'

export function getDevice(data) {
  return request({
    url: "/api/device",
    method: "POST",
    data: data,
  });
}

export function getDeviceDetail(data) {
  return request({
    url: "/api/device/detail",
    method: "POST",
    data: data,
  });
}

export function getGraphic(data) {
  return request({
    url: "/api/device/graphic",
    method: "POST",
    data: data,
  });
}


export function changeCbid(data) {
  return request({
    url: "/api/device/changeCbid",
    method: "POST",
    data: data,
  });
}

export function controlCbid(data) {
  return request({
    url: "/api/device/changeCbid",
    method: "POST",
    data: data,
  });
}



// WEBPACK FOOTER //
// ./src/api/device.js